module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "ocean-production--dataset-cover.24060eab.jpg";